import { getBlob, getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { useCallback } from 'react'
import { getStorage } from 'src/utils/firebase'

// default bucketのrootにあるディレクトリ
export const DefaultBucketDir = {
  Public: 'public',
  Static: 'static',
} as const
export type DefaultBucketDir = (typeof DefaultBucketDir)[keyof typeof DefaultBucketDir]

export const useStorage = (bucket?: string) => {
  const storage = getStorage(bucket)
  const uploadFile = useCallback(
    async (dir: DefaultBucketDir, file: File) => {
      const storageRef = ref(storage, `${dir}/${file.name}`)
      return await uploadBytes(storageRef, file)
    },
    [storage],
  )

  // 任意のフルパスにアップロードする（呼び出し側で衝突しないパスを組み立てる）
  const uploadFileToPath = useCallback(
    async (path: string, file: File) => {
      const storageRef = ref(storage, path)
      return await uploadBytes(storageRef, file)
    },
    [storage],
  )

  const getFileURL = useCallback(
    async (path: string, afterGet?: (src: string) => void | Promise<void>) => {
      const imgRef = ref(storage, path)
      const url = await getDownloadURL(imgRef)

      if (afterGet) {
        await afterGet(url)
      }

      return url
    },
    [storage],
  )

  // セキュリティルールを適用したい場合はこちらを使う。
  // getDownloadURL のトークンURLはルールをバイパスするため、認証付きでblobを取得する。
  const getFileBlobUrl = useCallback(
    async (path: string) => {
      const fileRef = ref(storage, path)
      const blob = await getBlob(fileRef)
      return URL.createObjectURL(blob)
    },
    [storage],
  )

  return { uploadFile, uploadFileToPath, getFileURL, getFileBlobUrl }
}
